export default "__VITE_ASSET__BK03dvbE__"